import React, { Component } from 'react';
import { Pagination } from 'react-bootstrap';
import _ from 'lodash';
import { underscored } from 'underscore.string';
import { withTranslation } from 'react-i18next';
import Spinner from '../../ui/LoadingCircle';
import Container from '../../v2/container';
import AddButton from '../../v2/buttons/AddButton';
import CargomaticModal from '../../v2/modal';
import CargomaticSelect from '../../v2/select';
import AccessorialCard from './AccessorialCard';
import AccessorialForm from './AccessorialForm';
import SessionStore from '../../../stores/SessionStore';
import { getAccessorials, deleteAccessorial, } from '../../../utils/AccessorialWebAPIUtils';
import ConfirmModal from '../../ui/modals/ConfirmModal';
import ToastStore from '../../../stores/ToastStore';
import Search from '../../v2/search';
import { sluggify } from '../../../utils/localization/utils';
const shipmentTypes = [
    {
        localizationSlug: 'DRAYAGE',
        value: 'drayage',
    },
    {
        localizationSlug: 'SHORTHAUL',
        value: 'shorthaul',
    },
];
class AccessorialManagementCenter extends Component {
    constructor(props) {
        super(props);
        this.fetchAccessorials = async () => {
            this.setState({ loading: true }, async () => {
                try {
                    const result = await getAccessorials(this.getFilters());
                    const { entity: { items, pages }, } = result;
                    const accessorials = items.map((a) => (Object.assign(Object.assign({}, a), { slug: a.slug || underscored(a.name.toLowerCase()) })));
                    this.setState({
                        accessorials,
                        loading: false,
                        pages,
                    });
                }
                catch (e) {
                    console.error(e);
                    this.setState({ loading: false });
                }
            });
        };
        this.handleSessionStoreChange = () => {
            this.setAccessLevel();
        };
        this.handleSelectPage = (eventKey) => {
            this.setState((prevState) => {
                return {
                    filters: Object.assign(Object.assign({}, prevState.filters), { page: eventKey }),
                };
            }, () => this.fetchAccessorials());
        };
        this.handleSelectShipmentType = (item) => {
            const { value: shipment_type } = item;
            this.setState((prevState) => {
                return {
                    filters: Object.assign(Object.assign({}, prevState.filters), { shipment_type, page: 1 }),
                };
            }, () => {
                this.fetchAccessorials();
            });
        };
        this.handleSearch = (name) => {
            this.setState((prevState) => {
                return {
                    filters: Object.assign(Object.assign({}, prevState.filters), { name, page: 1 }),
                };
            }, () => {
                this.fetchAccessorials();
            });
        };
        this.handleConfirmDelete = async () => {
            const { t } = this.props;
            try {
                await deleteAccessorial(this.state.selectedAccessorial);
                this.setState((prevState) => {
                    const { accessorials: currentAccessorials, selectedAccessorial } = prevState;
                    const index = currentAccessorials.findIndex((a) => a._id === selectedAccessorial._id);
                    return {
                        accessorials: [
                            ...currentAccessorials.slice(0, index),
                            ...currentAccessorials.slice(index + 1),
                        ],
                        selectedAccessorial: null,
                        showConfirmDelete: false,
                    };
                });
                ToastStore.addNotification({
                    level: 'success',
                    title: t('ACCESSORIAL_DELETED_SUCCESSFULLY'),
                });
            }
            catch (e) {
                console.error(e);
                ToastStore.addNotification({
                    level: 'error',
                    title: t('PROBLEM_DELETE_ACCESSORIAL'),
                });
            }
        };
        this.handleDeleteAccessorial = (id) => () => {
            this.setState((prevState) => {
                const accessorial = prevState.accessorials.find((a) => a._id === id);
                if (!accessorial) {
                    return null;
                }
                return {
                    showConfirmDelete: true,
                    selectedAccessorial: accessorial,
                };
            });
        };
        this.handleHideConfirmModal = () => {
            this.setState({ showConfirmDelete: false, selectedAccessorial: null });
        };
        this.handleAddAccessorial = () => {
            this.setState({ showAccessorialModal: true });
        };
        this.handleEditAccessorial = (id) => () => {
            this.setState((prevState) => {
                if (!prevState.canEdit) {
                    return null;
                }
                const accessorial = prevState.accessorials.find((a) => a._id === id);
                return {
                    showAccessorialModal: true,
                    selectedAccessorial: accessorial,
                };
            });
        };
        this.handleSaveAccessorialSuccess = () => {
            this.handleHideAccessorialModal();
            this.fetchAccessorials();
        };
        this.handleHideAccessorialModal = () => {
            this.setState({ showAccessorialModal: false, selectedAccessorial: null });
        };
        this.state = {
            loading: false,
            accessorials: [],
            showAccessorialModal: false,
            showConfirmDelete: false,
            selectedAccessorial: null,
            filters: {
                shipment_type: '',
                name: '',
                page: 1,
                per_page: 40,
                paginate: true,
            },
            pages: 1,
            canCreate: false,
            canEdit: false,
            canDelete: false,
        };
        this.fetchAccessorials = _.debounce(this.fetchAccessorials, 500);
    }
    componentDidMount() {
        const { t } = this.props;
        this.fetchAccessorials();
        SessionStore.addChangeListener(this.handleSessionStoreChange);
        this.setAccessLevel();
        document.title = t('CARGOMATIC_INC_ACCESSORIALS');
    }
    componentWillUnmount() {
        SessionStore.removeChangeListener(this.handleSessionStoreChange);
    }
    getFilters() {
        const { filters } = this.state;
        return Object.keys(filters).reduce((runningMap, key) => {
            if (filters[key]) {
                return Object.assign(Object.assign({}, runningMap), { [key]: filters[key] });
            }
            return Object.assign({}, runningMap);
        }, {});
    }
    getConfirmDeleteTitle() {
        const { t } = this.props;
        if (!this.state.showConfirmDelete) {
            return '';
        }
        return t('DELETE_ACCESSORIAL', {
            deleteAccessorial: this.state.selectedAccessorial.name,
        });
    }
    getModalTitle() {
        const { t } = this.props;
        const { selectedAccessorial } = this.state;
        if (selectedAccessorial) {
            return t('EDIT_ACCESSORIAL');
        }
        return t('ADD_ACCESSORIAL', { count: 1 });
    }
    setAccessLevel() {
        const canAccess = SessionStore.isGodAdmin() || SessionStore.hasAccessorialManagerRole();
        this.setState({
            canDelete: canAccess,
            canCreate: canAccess,
            canEdit: canAccess,
        });
    }
    renderAccessorials() {
        const { t } = this.props;
        if (this.state.accessorials.length === 0) {
            return React.createElement("p", null, t('NO_ACCESSORIALS'));
        }
        return (React.createElement("div", { className: "flex flex-wrap -mx-4" }, this.state.accessorials.map((accessorial) => (React.createElement(AccessorialCard, { key: accessorial._id, name: t(sluggify(accessorial.slug)), iconSlug: accessorial.icon_slug, className: "px-4 mb-4", slug: accessorial.slug, canSelect: this.state.canEdit, canDelete: this.state.canDelete, onSelect: this.handleEditAccessorial(accessorial._id), onDelete: this.handleDeleteAccessorial(accessorial._id) })))));
    }
    render() {
        const { t } = this.props;
        return (React.createElement(Container, null,
            React.createElement("div", { className: "min-h-screen -mx-4 mt-10" },
                React.createElement("div", { className: "flex items-center px-4 mb-4" },
                    React.createElement("h3", { className: "my-0 mr-2 text-lg font-medium" }, t('ACCESSORIAL_MANAGEMENT_CENTER')),
                    this.state.canCreate && (React.createElement(AddButton, { onClick: this.handleAddAccessorial }))),
                React.createElement("div", { className: "flex flex-wrap items-end mb-8" },
                    React.createElement("div", { className: "w-full px-4 md:w-1/3" },
                        React.createElement(Search, { value: this.state.filters.name, onChange: this.handleSearch })),
                    React.createElement("div", { className: "px-4" },
                        React.createElement(CargomaticSelect, { selected: this.state.filters.shipment_type, items: shipmentTypes, textKey: "localizationSlug", valueKey: "value", label: t('SHIPMENT_TYPE'), onSelect: this.handleSelectShipmentType, showCaption: true, applyDefaultMargins: false }))),
                React.createElement("div", { className: "px-4 mb-4" },
                    this.state.loading && React.createElement(Spinner, { text: t('LOADING') }),
                    this.renderAccessorials(),
                    this.state.pages > 1 && (React.createElement(Pagination, { first: true, last: true, ellipsis: true, items: this.state.pages, maxButtons: 10, activePage: this.state.filters.page, onSelect: this.handleSelectPage }))),
                this.state.showAccessorialModal && (React.createElement(CargomaticModal, { show: this.state.showAccessorialModal, title: this.getModalTitle(), onHide: this.handleHideAccessorialModal },
                    React.createElement(AccessorialForm, { accessorial: this.state.selectedAccessorial, onCancel: this.handleHideAccessorialModal, onSaveSuccess: this.handleSaveAccessorialSuccess }))),
                this.state.showConfirmDelete && (React.createElement(ConfirmModal, { show: this.state.showConfirmDelete, title: this.getConfirmDeleteTitle(), onConfirm: this.handleConfirmDelete, onHide: this.handleHideConfirmModal, message: t('ARE_YOU_SURE') })))));
    }
}
export default withTranslation()(AccessorialManagementCenter);
